export let routes = {
  index: '/',
  expired: '/session-expired',
  report: '/report/:userId',
  reviewAssessment: '/assessment-review/:assessmentId',
  signIn: '/sign-in',
  publicStart: '/group/:assessmentGroupSid',
  takeAssessment: '/assessment/:assessmentId',
  unauthorized: '/unauthorized',
  configError: '/config-error',
  serverError: '/server-error'
};
